<template>
   	<div class="rankBg">
		<ul class="rank_list">
			<li v-for="(item,index) in plistList" @click="toPlistPage(index)">
				<div class="image"><img :src="item.imgUrl" alt="" /></div>
				<div class="text">{{item.plistName}}
					<p class="plistNum">{{item.plistNum}}</p>
				</div>
				<div class="icon"><img src="../assets/images/arrow_icon.png" alt="" /></div>
			</li>
		</ul>
   	</div>
</template>

<script>
  export default {
    data () {
      return {
      	plistList:'',
      }
    },
    computed: {
    	
    },
    components:{

  	},
  	mounted:function(){
    	var _this=this;
    	//this.$nextTick(function(){
    		this.startView();
    	//})
    },
    methods: {
      startView:function(){
      	this.$store.commit('setGuodu',true);
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/newSongList?url=plist/index",
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('.panel-img-list li');
				var plistList = [];
				for(var i=0;i<list.length;i++){
					var plist={};
					plist.imgUrl=list[i].querySelector('.panel-img-left img').getAttribute('_src');
					plist.plistName=list[i].querySelector('.panel-img-content-first').textContent;
					plist.plistNum=list[i].querySelector('.panel-img-content-sub').textContent;
					plist.location="plist/list/"+list[i].querySelector('a').href.substr(30);
					plistList.push(plist);
				}
				console.log(plistList[0].plistNum)
				_this.plistList=plistList;
				_this.$store.commit('rankList',plistList);
				_this.$store.commit('setGuodu',false);
			},
			error:function(){
				alert(-1)
			}
		});
      },
      toPlistPage:function(index){
      	this.$store.commit('rankPageIndex',index);
      	this.$store.commit('setGuodu',true);
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/newSongList?url="+_this.plistList[index].location,
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('.panel-songslist-item');
				var songList = [];
				for(var i=0;i<list.length;i++){
					var song={};
					song.title=list[i].querySelector('.panel-songs-item-name span').textContent;
					song.hash=list[i].id.substr(6);
					songList.push(song);
				}
				setTimeout(function(){
					var rankTime=div.querySelector('.page-title').textContent;
					var plistText=div.querySelector('#introBox p').textContent;
					var rankImgUrl=div.querySelector('#imgBoxInfo img').getAttribute('src');
					_this.$store.commit('plistText',plistText);
					_this.$store.commit('rankTime',rankTime);
					_this.$store.commit('rankImgUrl',rankImgUrl);
					if(songList.length!=0){
						_this.$store.commit('setSongList',songList);
					}else{
						_this.$store.commit('setSongList',{'song':{'title':'服务器无数据返回，我也没办法 o(╯□╰)o，点其它歌单的吧...'}});
					}
					_this.$store.commit('setGuodu',false);
				},300);
				//_this.songList=songList;

			},
			error:function(){
				alert(-1)
			}
		});
		this.$router.push({path: '/plistPage'})
      },
    }
  }
</script>

<style scoped>
.rankBg{background: url(../../dist/bg01.jpg);width: 100%;height: 100%;background-size: 15%;}
.rank_list{background: url(../../dist/bg01.jpg);background-size: 15%;width: 100%;overflow: hidden;padding-left: 20px;box-sizing: border-box;position: absolute;top:129px;}
.rank_list li{width: 100%;overflow: hidden;border-bottom: 1px solid #333;margin-bottom: 18px;}
.rank_list li>div{float: left;margin-bottom: 14px;width: 80px;height: 70px;color: #ccc;font-size: 16px;margin-left: 10px;}
.rank_list .text{width: 52%;margin-left: 17px;padding-top: 5px;box-sizing: border-box;font-size: 15px;color: #f1f1f1;}
.rank_list li img{width: 70px;}
.rank_list .icon{width: 12px;float:right;margin-right: 22px;margin-left: 0;}
.rank_list .icon img{width: 10px;margin-top: 27px;}

.plistNum{font-size: 13px;margin-top: 4px;color: #ccc;background: url(../assets/images/icon_music.png) no-repeat -1px 2px;padding-left: 18px;background-size: 7%;}
</style>


// WEBPACK FOOTER //
// plist.vue?bada8e3e